import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import AppLayout from "@/components/AppLayout";
import Dashboard from "@/pages/Dashboard";
import Finance from "@/pages/Finance";
import Payroll from "@/pages/Payroll";
import LaborSub from "@/pages/LaborSub";
import CRM from "@/pages/CRM";
import MIS from "@/pages/MIS";
import WOScan from "@/pages/WOScan";
import Timesheet from "@/pages/Timesheet";
import Vendors from "@/pages/Vendors";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center text-muted-foreground text-sm">
        Loading Artisan Guild ERP…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/wo-scan/:id" element={<WOScan />} />
      <Route
        path="/"
        element={
          <Protected>
            <AppLayout />
          </Protected>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="finance" element={<Finance />} />
        <Route path="payroll" element={<Payroll />} />
        <Route path="labor" element={<LaborSub />} />
        <Route path="crm" element={<CRM />} />
        <Route path="mis" element={<MIS />} />
        <Route path="timesheet" element={<Timesheet />} />
        <Route path="vendors" element={<Vendors />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
